module.exports = __webpack_public_path__ + "img/daily_specials_2.cbf9b549.jpg";